
import MarqueeText from '../ui/marqueeText.vue';

export default {
  name: 'SlidingText',

  components: {
    MarqueeText,
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  computed: {
    blockStyle() {
      return {
        backgroundColor: this.data.bg_color || 'transparent',
        color: this.data.text_color || '#201f20',
      };
    },
  },
};
